module.exports = __webpack_public_path__ + "static/media/lykke10.25eb822e.jpg";